import Vue from "vue";
import { orderToCancel } from "@http/order/index";
// 取消订单通用方法
export function cancelOrderCommon (orderInfo) {
    return new Promise((resolve, reject) => {
        let orderId = orderInfo.order.id;
        Vue.prototype.$confirm('确认取消该订单吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning'
        }).then(() => {
            const loading = Vue.prototype.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
            });
            orderToCancel({orderId}).then(async (res)=>{
                loading.close();
                resolve(res);
            }).catch((error) => {
                loading.close();
                Vue.prototype.$msg("该订单取消失败，请稍后再试");
                reject(error)
            });
        })
    })
}
// 继续支付通用方法
export function continuePayOredrCommon (orderInfo) {
    let sourceType = Vue.prototype.$getlocalStorage("queryData")?.sourceType || Vue.prototype.$getlocalStorage("queryData")?.clientId || 975260;
    let orderId = orderInfo.order.id;
    window.location.href=`/api/order/continuePay?orderId=${orderId}&sourceType=${sourceType}`
}